import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import EmailAntispamAPI from '../../api/emailAntispam';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    creatingItem: false,
    deletingItem: false,
  },
};

const getters = {
  getEmailAntispamEntries(_state) {
    return _state.records;
  },
  getEmailAntispamUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  getEmailAntispamEntries: async function getEmailAntispamEntries({ commit }) {
    commit(types.default.SET_EMAIL_ANTISPAM_UI_FLAG, { fetchingList: true });
    try {
      const response = await EmailAntispamAPI.get();
      commit(types.default.SET_EMAIL_ANTISPAM_ENTRIES, response.data);
    } catch (error) {
      // ignore
    } finally {
      commit(types.default.SET_EMAIL_ANTISPAM_UI_FLAG, { fetchingList: false });
    }
  },

  createEmailAntispamEntry: async function createEmailAntispamEntry(
    { commit },
    email
  ) {
    commit(types.default.SET_EMAIL_ANTISPAM_UI_FLAG, { creatingItem: true });
    try {
      const response = await EmailAntispamAPI.create(email);
      commit(types.default.ADD_EMAIL_ANTISPAM_ENTRY, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_EMAIL_ANTISPAM_UI_FLAG, { creatingItem: false });
    }
  },

  deleteEmailAntispamEntry: async function deleteEmailAntispamEntry(
    { commit },
    id
  ) {
    commit(types.default.SET_EMAIL_ANTISPAM_UI_FLAG, { deletingItem: true });
    try {
      await EmailAntispamAPI.delete(id);
      commit(types.default.DELETE_EMAIL_ANTISPAM_ENTRY, id);
      return id;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_EMAIL_ANTISPAM_UI_FLAG, { deletingItem: false });
    }
  },
};

const mutations = {
  [types.default.SET_EMAIL_ANTISPAM_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.default.SET_EMAIL_ANTISPAM_ENTRIES]: MutationHelpers.set,
  [types.default.ADD_EMAIL_ANTISPAM_ENTRY]: MutationHelpers.create,
  [types.default.DELETE_EMAIL_ANTISPAM_ENTRY]: MutationHelpers.destroy,
};

export default { state, getters, actions, mutations };
